import { ref, update } from 'firebase/database'

import { promoteRegistrationToTournament, updateTournamentInfo } from './data.js'
import { executeAIAction } from '../utils/aiActionExecutor.js'
import { db, tref } from './firebase.js'
import { qeAudit } from './qeAudit.js'

// Build the live PBCC 4-Ball tournament from a locked/approved qualifying
// field: promote the SAME registration node (syncs its scores), run the
// deterministic PBCC build on that explicit id, then restore lifecycle flags.
// Shared by BuildPickerModal ("Review field & build → Build with AI") and the
// Qualifying page's "Submit to Tournament" button so both take ONE path.
// Lives in lib (not AdminApp) so importing it never creates a circular
// dependency — that circularity left the binding undefined under HMR, which is
// why "Submit to Tournament" silently did nothing.
export async function buildTournamentFromQualifying(registrationId, qualifyingEventId, { isPractice = false } = {}) {
  qeAudit('buildTournamentFromQualifying:start', { registrationId, qualifyingEventId, isPractice }) // TEST tripwire
  await promoteRegistrationToTournament(registrationId, qualifyingEventId)
  // Flag practice BEFORE the build so PBCC_BUILD clones the template's flights
  // VERBATIM (demo-identical structure) rather than rebuilding them.
  if (isPractice) await updateTournamentInfo(registrationId, { isDemo: true, isPractice: true })
  const r = await executeAIAction('PBCC_BUILD_FROM_QUALIFYING', {}, registrationId, db)
  if (!r?.success) throw new Error(r?.message || 'PBCC build failed.')
  // The build clones template.info; restore lifecycle flags. A practice build
  // stays flagged isDemo/isPractice so it shows in My Tournaments BADGED (not
  // hidden, not counted as real) — the flow can be verified end to end.
  await updateTournamentInfo(registrationId, {
    stage: 'active',
    ...(isPractice ? { isDemo: true, isPractice: true } : {}),
  })
  // Mark the qualifying event as built so it drops out of the Qualifying
  // section — advanced, the same way a registration leaves Registration once
  // it's submitted to qualify.
  if (qualifyingEventId) {
    qeAudit('buildTournamentFromQualifying:setBuiltTournamentId', { registrationId, qualifyingEventId }) // TEST tripwire: hides event from Qualifying list
    await update(tref(`qualifyingEvents/${qualifyingEventId}/info`), { builtTournamentId: registrationId })
  }
  return r
}
